/** Max longitude within one rashi: 29°59′59″ (< 30°). Whole-number entry uses 0–29. */
export const MAX_INTEGER_DEGREE_IN_SIGN = 29;

/** @deprecated Use MAX_INTEGER_DEGREE_IN_SIGN for UI; kept for engine clamping. */
export const MAX_DEGREE_IN_SIGN = 29 + 59 / 60 + 59 / 3600;

export const DEGREE_IN_SIGN_HINT_HI =
  ' किसी भी ग्रह की राशि में अधिकतम अंश 29°59′59″ है - पूरांक अंश ही भरें (0–29)।';
export const DEGREE_IN_SIGN_HINT_EN =
  'Maximum degree within a Rashi is 29°59′59″ - enter whole degrees only (0–29).';

export const DEGREE_IN_SIGN_ERROR_HI =
  'पूरांक अंश 0 से 29 के बीच होना चाहिए (30° अगली राशि में है)।';
export const DEGREE_IN_SIGN_ERROR_EN =
  'Whole degree must be between 0 and 29 (30° belongs to the next sign).';

/**
 * @param {string|number|null|undefined} raw
 * @returns {number|null} Parsed whole number, or null if empty / not an integer.
 */
export function parseDegreeInSign(raw) {
  if (raw === '' || raw == null) return null;
  const s = String(raw).trim();
  if (!/^\d+$/.test(s)) return null;
  return Number(s);
}

/**
 * @param {number|null|undefined} n
 * @returns {boolean}
 */
export function isValidDegreeInSign(n) {
  if (n == null || !Number.isFinite(n)) return false;
  return Number.isInteger(n) && n >= 0 && n <= MAX_INTEGER_DEGREE_IN_SIGN;
}

/**
 * @param {string|number|null|undefined} raw
 * @returns {{ valid: boolean; value: number|null; empty: boolean }}
 */
export function validateDegreeInSign(raw) {
  if (raw === '' || raw == null) {
    return { valid: true, value: null, empty: true };
  }
  const value = parseDegreeInSign(raw);
  if (value == null) {
    return { valid: false, value: null, empty: false };
  }
  return { valid: isValidDegreeInSign(value), value, empty: false };
}

/**
 * Keep digits only while typing - do not clamp; validation shows the error.
 * @param {string} raw
 * @returns {string}
 */
export function sanitizeIntegerDegreeInput(raw) {
  if (raw === '' || raw == null) return '';
  return String(raw).replace(/\D/g, '');
}

/**
 * Clamp to valid in-sign whole-degree range (for engines that need a safe number).
 * @param {number} n
 * @returns {number}
 */
export function clampDegreeInSign(n) {
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(MAX_INTEGER_DEGREE_IN_SIGN, Math.trunc(n)));
}
